/* eslint-disable consistent-return */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import {
    ConversationsList,
    PagedResponse,
    PagedSortedFilteredRequestParams,
    SortColumn,
    SortDirection,
} from '@centecomm/portal-service';
import { useConversations, useUserTasks } from '@centecomm/portal-service-react';
import { IconColors, MessageCircle, SecondaryMenu, Tasks } from 'Icons';
import { FlexWrapper } from 'Shared/FlexWrapper';
import { Types as TableTypes } from 'Shared/Table';
import { conversationsActions, conversationsSelectors } from 'State';
import { LoadStatus } from 'Types/AsyncState/LoadStatus';
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link, useHistory } from 'react-router-dom';
import NavBubble from './NavBubble';
import CompanyLogo from './CompanyLogo';
import NavigationAccountRow from './NavigationAccount/AccountRow/NavigationAccountRow';
import UserPanel from './NavigationAccount/AccountRow/UserPanel';
import styles from './navigation.module.css';

interface BottomNavRowProps {
    navIsOpen: boolean;
}

const sortColumn: SortColumn[] = [{ columnName: 'Id', sortDirection: TableTypes.SortDirection.DESC }];

// TODO: Handle Notification Count
function BottomNavRow({ navIsOpen }: BottomNavRowProps): React.ReactElement<BottomNavRowProps> {
    const { listen } = useHistory();
    const dispatch = useDispatch();

    const { getAllConversations } = useConversations();
    const { getTasks } = useUserTasks();

    const conversationLoadStatus = useSelector(conversationsSelectors.conversationsLoadStatus);
    const unreadMessageCount = useSelector(conversationsSelectors.unreadMessageCount);

    const [tasksCount, setTasksCount] = useState<number>(0);
    const [panelIsOpen, togglePanelIsOpen] = useState<boolean>(false);

    const closePanelOnRouteChange = () => {
        togglePanelIsOpen(false);
    };

    // @ts-ignore
    useEffect(() => {
        const routeListener = listen(closePanelOnRouteChange);

        return routeListener;
    }, []);

    useEffect(() => {
        if (conversationLoadStatus === LoadStatus.INITIAL_STATE) {
            dispatch({
                type: conversationsActions.LOAD_CONVERSATIONS,
            });
            const params = new PagedSortedFilteredRequestParams(
                [
                    {
                        columnName: 'unreadMessages',
                        sortDirection: SortDirection.DESC,
                    },
                    {
                        columnName: 'id',
                        sortDirection: SortDirection.DESC,
                    },
                ],
                [],
                500,
                1,
            );

            getAllConversations(params)
                .then((conversation: PagedResponse<ConversationsList>) => {
                    dispatch({
                        type: conversationsActions.SET_CONVERSATIONS,
                        payload: conversation.results,
                    });
                })
                .catch(() => {
                    // TODO: Handle error
                });
        }
    }, [conversationLoadStatus]);

    useEffect(() => {
        getTasks(new PagedSortedFilteredRequestParams(sortColumn, [], 1, 0)).then((response) =>
            setTasksCount(response.totalCount),
        );
    }, []);

    const handlePanel = () => {
        togglePanelIsOpen(!panelIsOpen);
    };

    if (navIsOpen)
        return (
            <div className={styles.BottomNavRow}>
                <FlexWrapper align="center" justify="end" gap="1.35rem" className={styles.TopRow}>
                    <CompanyLogo />
                    <Link to="/conversations" data-qa-navigation-link="Conversations" className={styles.IconCallout}>
                        {unreadMessageCount > 0 && (
                            <NavBubble>
                                <p>{unreadMessageCount}</p>
                            </NavBubble>
                        )}
                        <MessageCircle color={IconColors.MediumGrey} aspect="1.75rem" />
                    </Link>
                    <Link to="/tasks" data-qa-navigation-link="Tasks" className={styles.IconCallout}>
                        {tasksCount > 0 && (
                            <NavBubble>
                                <p>{tasksCount}</p>
                            </NavBubble>
                        )}
                        <Tasks color={IconColors.MediumGrey} aspect="1.75rem" />
                    </Link>
                </FlexWrapper>
                <NavigationAccountRow />
            </div>
        );

    return (
        <>
            <FlexWrapper column align="center" justify="end" gap="1.35rem" className={styles.TopRow}>
                <Link to="/conversations" data-qa-navigation-link="Conversations" className={styles.IconCallout}>
                    {unreadMessageCount > 0 && (
                        <NavBubble>
                            <p>{unreadMessageCount}</p>
                        </NavBubble>
                    )}
                    <MessageCircle color={IconColors.MediumGrey} aspect="1.75rem" />
                </Link>
                <Link to="/tasks" data-qa-navigation-link="Tasks" className={styles.IconCallout}>
                    {tasksCount > 0 && (
                        <NavBubble>
                            <p>{tasksCount}</p>
                        </NavBubble>
                    )}
                    <Tasks color={IconColors.MediumGrey} aspect="1.75rem" />
                </Link>
            </FlexWrapper>
            <div className={styles.CollapsedBottomNavRow}>
                {panelIsOpen && (
                    <div className={styles.CollapsedAccountRowPanel}>
                        <UserPanel />
                    </div>
                )}
                <button
                    type="button"
                    onClick={handlePanel}
                    className={styles.CollapsedActionButton}
                    data-qa="bottom-navigation-toggle-user-panel"
                >
                    <SecondaryMenu color={IconColors.MediumGrey} aspect="1.5rem" />
                </button>
            </div>
        </>
    );
}

export default BottomNavRow;
